export function gameLang(locale) {
  if (locale === 'tr') return 'tr';
  if (locale === 'ru') return 'ru';
  if (locale === 'de') return 'de';
  if (locale === 'fr') return 'fr';
  if (locale === 'nl') return 'nl';
  return 'en';
}
